import type { StudioNotebookPdfVariant } from "./studio-notebook-pdf-model";

// The names a Studio notebook is saved under. In lib, not with the page, because the PDF export uses them too
// (spark#1252, @adr SPARK-0062-studio-notebooks-export-as-pdf@1).

/** The Markdown export's file name: the notebook's name as a slug, umlauts spelled out. */
export function notebookFileName(name: string): string {
  const slug = name
    .toLowerCase()
    .replace(/ä/g, "ae")
    .replace(/ö/g, "oe")
    .replace(/ü/g, "ue")
    .replace(/ß/g, "ss")
    .normalize("NFKD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
  return `${slug || "notebook"}.md`;
}

/** The PDF's file name: the Markdown export's name with `.pdf`, and `-final` for the final version. */
export function notebookPdfFileName(name: string, variant: StudioNotebookPdfVariant): string {
  return notebookFileName(name).replace(/\.md$/, variant === "final" ? "-final.pdf" : ".pdf");
}
